/**
 * WatchedData
 *
 * A class that can be used for data returned from Watchables.
 */
export default class WatchedData {
  getKey() {
    throw new Error(
      'Subclassed of WatchedData should implement a getKey method',
    );
  }

  toString() {
    return '[WatchedData]';
  }
}
